import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import StudentCard from "./StudentCard";
import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";

const StudentsData = ({ userData, getNextStudents }) => {
  const { students, hasMore, totalLength } = useSelector(
    (state) => state.studentsPagination,
  );
  const { openConfirmModal } = useSelector((state) => state.studentsModal);
  const [openMoreModal, setOpenMoreModal] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(1);

  const tableHead = [
    "Tələbə adı",
    "Fin",
    "Seriya",
    "Doğum günü",
    "Mobil nömrə",
    "Email",
    "Lead haradan gəlib",
    "Haradan gəliblər",
    "Satış bölgüsü",
    "İxtisas",
    "Qrup",
    "Q/B",
    "TPN",
    "Borc statusu",
    "Diplom statusu",

    "",
  ];

  useEffect(() => {
    if (openMoreModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "overlay";
    }
  }, [openMoreModal]);

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight,
      );
    };

    setScrollHeight(
      window.innerHeight - mainHeader.offsetHeight - detailsHeader.offsetHeight,
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {openConfirmModal && <ConfirmModal type="student" />}

      <InfiniteScroll
        dataLength={students.length}
        next={getNextStudents}
        hasMore={hasMore}
        loader={<SmallLoading />}
        endMessage={<p style={{ textAlign: "center", fontSize: "20px" }}></p>}
        height={scrollHeight}
        scrollThreshold={0.7}
      >
        <table
          style={{ marginBottom: "50px" }}
          className={`details-table  student-table ${
            userData.power === "only-show" ? "only-show" : "update"
          } `}
        >
          <thead>
            <tr>
              {tableHead.map((head, i) => (
                <th
                  key={i}
                  className={`table-head-w ${
                    head === "Fin" || head === "Seriya"
                      ? "fin-w"
                      : head === "Tələbə adı"
                        ? "student-name-w"
                        : head === "Mobil nömrə"
                          ? "phone-w"
                          : head === "Haradan gəliblər" ||
                              head === "Lead haradan gəlib"
                            ? "whereHeard-w"
                            : head === "İxtisas"
                              ? "course-w"
                              : head === "Satış bölgüsü" || head === "Qrup"
                                ? "sales-w"
                                : head === "Q/B"
                                  ? "qb-w"
                                  : head === "Doğum günü"
                                    ? "student-birthday-w"
                                    : head === "Email"
                                      ? "student-email-w"
                                      : ""
                  } `}
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {students?.map((student, i) => (
              <StudentCard
                key={student._id}
                data={student}
                mode="desktop"
                student={userData}
                setOpenMoreModal={setOpenMoreModal}
                cellNumber={totalLength - i}
              />
            ))}
          </tbody>
        </table>
      </InfiniteScroll>

      <div className="details-list-tablet with-more">
        {students?.map((student, i) => (
          <StudentCard
            key={student._id}
            data={student}
            mode="tablet"
            student={userData}
            setOpenMoreModal={setOpenMoreModal}
            cellNumber={i + 1}
          />
        ))}
      </div>
    </>
  );
};

export default StudentsData;
